module.exports = __webpack_public_path__ + "assets/element-ui.ba99f6df.svg";